<template>
    <PageContainer>
        <PageHeader>
            {{ $t('stock.index.page_title') }}
        </PageHeader>

        <SearchPanel
            :search="search"
            url="/stock"
            :only="['logs', 'search', 'gender']"
            :extra="{'gender': genderValue}"
        >
            <div class="col">
                <select
                    v-model="genderValue"
                    class="form-select"
                >
                    <option
                        v-for="item in genders"
                        :key="item.value"
                        :value="item.value"
                    >{{ item.name }}</option>
                </select>
            </div>
        </SearchPanel>

        <base-table>
            <template #thead>
                <th>{{ $t('stock.product_name') }}</th>
                <th>{{ $t('stock.size') }}</th>
                <th>{{ $t('stock.quantity') }}</th>
                <th></th>
            </template>
            <tr v-for="log in pagination.data" class="align-middle" :key="log.product_size_id">
                <td>{{ log?.product?.name }}</td>
                <td>{{ log?.product_size?.size }}</td>
                <td>{{ log?.remaining_quantity }}</td>
                <td class="text-end"></td>
            </tr>
        </base-table>

        <Pagination
            :pagination="pagination.pagination"
        />
    </PageContainer>
</template>

<script setup lang="ts">
import BaseTable from "@/components/elements/BaseTable.vue";
import Pagination from "@/components/elements/Pagination.vue";
import type {PaginatedResponse, StockInterface} from "@/components/helpers/Interfaces.ts";
import {usePagination} from "@/Composable/usePagination.ts";
import PageHeader from "@/components/elements/PageHeader.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
import SearchPanel from "@/components/elements/SearchPanel.vue";
import type {SelectOption} from "@/components/types.ts";
import {ref} from "vue";

type StockType = Pick<StockInterface, 'product_id'|'product_size_id'|'remaining_quantity'|'product'|'product_size'>

const { logs, search = null, gender = 0, genders } = defineProps<{
    logs: PaginatedResponse<StockType>,
    search?: string,
    gender: number,
    genders: Array<SelectOption>
}>()

const genderValue = ref<number>(gender)

const pagination = usePagination<StockType>(logs)
</script>

<style scoped>

</style>
